module.exports = __webpack_public_path__ + "img/txt-1-f@2x.30cfcb38.png";